import { render, staticRenderFns } from "./bgImgContainer.vue?vue&type=template&id=a4701bb6&scoped=true&"
import script from "./bgImgContainer.vue?vue&type=script&lang=ts&"
export * from "./bgImgContainer.vue?vue&type=script&lang=ts&"
import style0 from "./bgImgContainer.vue?vue&type=style&index=0&id=a4701bb6&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a4701bb6",
  null
  
)

export default component.exports